<template>
  <div>
    <label v-if="title"
      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
    >
      {{ title }}
    </label>
    <div class="radio_wrapper">
      <label class="radiooption" v-bind:class="{ formElementError: errorMsg }" :for="inputId">
        <input
          class="mr-3"
          type="checkbox"
          :id="inputId"
          :value="value"
          :checked="shouldBeChecked"
          @change="updateInput"
        />
        {{ option_text }}
      </label>
          <p v-if="errorMsg" class="formErrorMsg">
      {{ errorMsg }}
    </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    title: String,
    option_text: String,
    value: Boolean,
    modelValue: {
      default: false
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    },
    errorMsg: {
      type: String,
      default: null
    }
  },
  computed: {
    shouldBeChecked() {
      return this.modelValue === this.trueValue;
    },
  },
  data() {
    return {
      inputId: "checkbox-" + this.title,
    };
  },
  methods: {
    updateInput(event) {
      let isChecked = event.target.checked
      this.$emit('change', isChecked ? this.trueValue : this.falseValue)
    },
  },
};
</script>